// GameConstants.js - 游戏常量配置
// 集中管理所有硬编码的魔法数字和配置

export const GAME_CONSTANTS = {
    // 地图相关
    TILE_SIZE: 32,
    
    // 玩家相关
    PLAYER: {
        BASE_SPEED: 60,
        VEHICLE_SPEED_MULTIPLIER: 2.0,
        BASE_HP: 50,
        BASE_ATTACK: 10,
        BASE_DEFENSE: 5,
        BASE_MONEY: 5000
    },
    
    // 战斗相关
    BATTLE: {
        BASE_CRITICAL_CHANCE: 0.1,      // 基础暴击率 10%
        CRITICAL_MULTIPLIER: 1.5,        // 暴击倍率
        ESCAPE_CHANCE: 0.5,              // 逃跑成功率 50%
        MIN_DAMAGE: 1,                   // 最小伤害
        DAMAGE_VARIATION: 0.2,           // 伤害浮动范围 20%
        FIXED_BATTLE_INTRO_MS: 1000,     // 固定敌人战入场等待（可按空格跳过）
        ENEMY_ATTACK_STAGGER_MS: 250,    // 多敌人回合内攻击间隔
        FOCUS_FIRE_DAMAGE_MULTIPLIER: 1.25, // 集火标记伤害加成
        IMPLEMENTED_WEAPON_SPECIALS: ['fire', 'ice', 'pierce']
    },

    // 状态效果
    STATUS: {
        BURN_TURNS: 1,
        SLOW_TURNS: 1,
        SLOW_DAMAGE_MULTIPLIER: 0.5
    },
    
    // 遇敌相关
    ENCOUNTER: {
        COOLDOWN: 10000,                 // 遇敌冷却时间（毫秒）
        BASE_CHANCE: 0.001,              // 基础遇敌概率 0.1%
        VEHICLE_CHANCE_MULTIPLIER: 0.5,  // 战车遇敌概率倍率
        SPEED_THRESHOLD: 60,             // 速度阈值（超过此速度增加遇敌概率）
        MIN_SPEED_FOR_ENCOUNTER: 5       // 触发遇敌的最小速度
    },
    
    // 奖励相关
    REWARD: {
        BASE_EXP_MULTIPLIER: 1.0,
        BASE_MONEY_MULTIPLIER: 1.0,
        LEVEL_UP_STATS: {
            MAX_HP: 10,
            ATTACK: 2,
            DEFENSE: 1,
            SPEED: 1
        },
        NEXT_LEVEL_EXP_BASE: 100,
        NEXT_LEVEL_EXP_MULTIPLIER: 1.5
    },
    
    // UI相关
    UI: {
        DIALOG_DELAY: 500,               // 对话框显示延迟（毫秒）
        MESSAGE_AUTO_CLOSE: 2000,        // 消息自动关闭时间（毫秒）
        HUD_HEIGHT: 50,                  // HUD高度
        DIALOG_HEIGHT: 150               // 对话框高度
    },
    
    // 动画相关
    ANIMATION: {
        PLAYER_FRAME_RATE: 10,
        VEHICLE_FRAME_RATE: 8,
        NPC_FLOAT_DURATION: 1500,
        NPC_BREATHE_DURATION: 2000
    },
    
    // 交互相关
    INTERACTION: {
        NPC_INTERACTION_RADIUS: 50,      // NPC交互半径
        OBJECT_INTERACTION_RADIUS: 25    // 物体交互半径
    },
    
    // 存档相关（服务端为单存档，slot 参数仅兼容旧 UI）
    SAVE: {
        MAX_SLOTS: 1,
        HISTORY_LIMIT: 50
    },

    // 自动存档
    AUTO_SAVE: {
        DEBOUNCE_MS: 2000,
        MIN_INTERVAL_MS: 30000,
        PERIODIC_MS: 300000,
        PERIODIC_CHECK_MS: 60000
    },

    // 多人同步
    MULTIPLAYER: {
        POSITION_UPDATE_INTERVAL_MS: 100,
        MIN_SEND_DISTANCE_SQ: 1,
        REMOTE_LERP_MS: 100,
        REMOTE_SNAP_DISTANCE: 128
    },
    
    // 商店相关
    SHOP: {
        SELL_PRICE_RATIO: 0.5,           // 出售价格比例（原价的50%）
        BASE_EQUIPMENT_PRICE: 20,        // 基础装备价格
        BASE_CONSUMABLE_PRICE: 10        // 基础消耗品价格
    }
};

